import { render, staticRenderFns } from "./videoTitle.vue?vue&type=template&id=3a03207f&"
import script from "./videoTitle.vue?vue&type=script&lang=js&"
export * from "./videoTitle.vue?vue&type=script&lang=js&"
import style0 from "./videoTitle.vue?vue&type=style&index=0&id=3a03207f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports